// Webpack consumes this global assignment when compiling its runtime.
// eslint-disable-next-line no-unused-vars
/* global __webpack_public_path__: writable */
// This module must run before the entry's other imports can request lazy assets.
const catalogue = document.getElementById("recs-catalogue");
if (catalogue) {
  // The script-path fallback supports an older, already-open catalogue document
  // that fetches the new manifest without setting the new loader attribute.
  const scriptBase = document.currentScript?.src.match(
    /(\/catalogue-controls\/[a-f0-9]{12}\/)static\//,
  )?.[1];
  const assetBase = catalogue.dataset.controlsAssetBase || scriptBase;
  if (!/^\/catalogue-controls\/[a-f0-9]{12}\/$/.test(assetBase || "")) {
    throw new Error("The controls asset location is unavailable.");
  }
  __webpack_public_path__ = assetBase;
}
